import React, { useEffect, useState } from 'react';
import { connect } from 'umi';
import ModalFormPro from '@/components/ModalFormPro';
import TablePro from '@/components/TablePro';
import { gettaskplanexcellist } from '@/_serveice/task';

const AddTabModal = ({ visible, onCancel, onSave, tabs = [] }) => {
  const [tableData, setTableData] = useState([]);
  const [selectedSheetId, setSelectedSheetId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  useEffect(() => {
    if (selectedSheetId) {
      gettaskplanexcellist({ taskExcelSheetId: selectedSheetId }).then(
        (res) => {
          if (res.data) {
            setTableData(Array.isArray(res.data) ? res.data : []);
            setSelectedRows([]); // 清空选中内容
          }
        },
      );
    } else {
      setTableData([]);
      setSelectedRows([]); // 清空选中内容
    }
  }, [selectedSheetId]);

  const rowSelection = {
    selectedRowKeys: selectedRows,
    onChange: (selectedRowKeys) => {
      setSelectedRows(selectedRowKeys);
    },
  };

  const handleSave = (values) => {
    let params = {
      ...values,
      taskIdList: selectedRows,
    };
    console.log('params', params);
    onSave?.(params);
  };

  const columns = [
    {
      title: 'WDP项目名',
      dataIndex: 'projectName',
      width: 100,
    },
    {
      title: '工作包',
      dataIndex: 'servCatgName',
      width: 150,
    },
    {
      title: '任务名称',
      dataIndex: 'taskName',
      width: 200,
    },
    {
      title: '客户',
      dataIndex: 'custName',
      width: 100,
    },
    {
      title: '负责人',
      dataIndex: 'taskLeaderName',
      width: 100,
    },
  ];

  const edtaFormItem = [
    {
      label: '表名',
      name: 'excelSheetName',
      type: 'Input',
      required: '请输入表名',
      props: {
        placeholder: '请输入表名',
      },
    },
    {
      label: '关联表',
      name: 'excelSheetId',
      type: 'Select',
      props: {
        placeholder: '请选择关联表',
        options: tabs.map((tab) => ({
          label: tab.name,
          value: tab.taskExcelSheetId,
        })),
        allowClear: true,
        onChange: (value) => setSelectedSheetId(value),
      },
    },
    selectedSheetId !== null && {
      full: true,
      render() {
        return (
          <TablePro
            columns={columns}
            dataSource={tableData}
            curColumns
            columnsOptions={false}
            rowKey="taskId"
            pagination={false}
            scroll={{ y: 300 }}
            rowSelection={{
              type: 'checkbox',
              ...rowSelection,
            }}
          />
        );
      },
    },
  ].filter((item) => item);

  return (
    <ModalFormPro
      title="新增表"
      visible={visible}
      width={1000}
      edtaFormItem={edtaFormItem}
      onSave={handleSave}
      onCancel={onCancel}
    ></ModalFormPro>
  );
};

export default connect()(AddTabModal);
